import { toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { createId } from './createId.js';

function findNode(node, path) {
  var current = node;
  for (var i = 0; i < path.length; i += 1) {
    current = current.children[path[i]];
    if (current == null) {
      return null;
    }
  }
  return current;
}
function findAncestorNodes(document, path) {
  if (path.length === 0) {
    return [];
  }
  return [findNode(document, [])].concat(_toConsumableArray(path.map(function (_, i) {
    return findNode(document, path.slice(0, i + 1));
  }))).filter(function (s) {
    return !!s;
  });
}
function setNode(node, path, value) {
  if (path.length === 0) {
    return value;
  }
  return _objectSpread2(_objectSpread2({}, node), {}, {
    children: node.children.map(function (child, i) {
      if (i === path[0]) {
        return setNode(child, path.slice(1), value);
      }
      return child;
    })
  });
}
function removeNode(node, path) {
  if (path.length === 1) {
    return _objectSpread2(_objectSpread2({}, node), {}, {
      children: node.children.filter(function (_, i) {
        return i !== path[0];
      })
    });
  }
  return _objectSpread2(_objectSpread2({}, node), {}, {
    children: node.children.map(function (child, i) {
      if (i === path[0]) {
        return removeNode(child, path.slice(1));
      }
      return child;
    })
  });
}
function insertNode(node, path, value) {
  if (path.length === 1) {
    return _objectSpread2(_objectSpread2({}, node), {}, {
      children: [].concat(_toConsumableArray(node.children.slice(0, path[0])), [_objectSpread2(_objectSpread2({}, value), {}, {
        children: value.children.map(function (child) {
          var _child$key;
          return _objectSpread2(_objectSpread2({}, child), {}, {
            key: (_child$key = child.key) !== null && _child$key !== void 0 ? _child$key : createId()
          });
        })
      })], _toConsumableArray(node.children.slice(path[0])))
    });
  }
  return _objectSpread2(_objectSpread2({}, node), {}, {
    children: node.children.map(function (child, i) {
      if (i === path[0]) {
        return insertNode(child, path.slice(1), value);
      }
      return child;
    })
  });
}
function canInsertNode(components, document, path, value) {
  var parent = findNode(document, path.slice(0, -1));
  var ancestors = findAncestorNodes(document, path).map(function (_ref) {
    var type = _ref.type;
    return type;
  });
  if (parent == null) {
    return false;
  }
  var ParentComponent = components[parent.type];
  var ChildComponent = components[value.type];
  var isChildAllowed = ParentComponent.allowedChildren == null || ParentComponent.allowedChildren.includes(value.type);
  var isParentAllowed = ChildComponent.allowedParent == null || ChildComponent.allowedParent.includes(parent.type);
  var isAncestorAllowed = ChildComponent.disallowedAncestors == null || !ChildComponent.disallowedAncestors.some(function (a) {
    return ancestors.indexOf(a) !== -1;
  });
  return isChildAllowed && isParentAllowed && isAncestorAllowed;
}
function canMoveNode(components, document, srcPath, destPath) {
  var src = findNode(document, srcPath);
  if (src == null) {
    return false;
  }
  // Check the validity of the movement; For example, we can't ever move
  // the parent into the children.
  var isParent = srcPath.length <= destPath.length && srcPath.every(function (v, i) {
    return destPath[i] === v;
  });
  if (isParent) {
    return false;
  }
  return canInsertNode(components, document, destPath, src);
}
function moveNode(document, srcPath, destPath) {
  // Remove (pluck) the node and try to store it into the destination.
  var srcNode = findNode(document, srcPath);
  if (srcNode == null) {
    return {
      document: document,
      cursor: destPath
    };
  }
  var removedDocument = removeNode(document, srcPath);
  // Re-insert the document to target.
  // But wait! If the srcPath and destPath sufficiently colides, the destPath
  // must be decreased by 1.
  // For example,
  // - A [0]
  //   - B [0, 0]
  //   - C [0, 1]
  //     - D [0, 1, 0]
  // Suppose that B [0, 0] is being moved inside C [0, 1, 0]. In the insertion
  // time, the B node would be removed from the document, therefore
  // C's offset will be changed to [0, 0].
  var destFixedPath = destPath;
  // It only happens if the src node is shallower than the dest node.
  if (srcPath.length <= destPath.length && srcPath.every(function (v, i) {
    if (i < srcPath.length - 1) {
      return v === destPath[i];
    }
    return v < destPath[i];
  })) {
    // Decrease the offending offset by 1.
    destFixedPath = destPath.map(function (v, i) {
      if (i === srcPath.length - 1) {
        return v - 1;
      }
      return v;
    });
  }
  // Insert the node in the position.
  return {
    document: insertNode(removedDocument, destFixedPath, srcNode),
    cursor: destFixedPath
  };
}
function cloneNode(node) {
  var removeKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    key: removeKey ? null : createId(),
    type: node.type,
    props: node.props,
    children: node.children.map(function (child) {
      return cloneNode(child, removeKey);
    })
  };
}

export { canInsertNode, canMoveNode, cloneNode, findAncestorNodes, findNode, insertNode, moveNode, removeNode, setNode };
//# sourceMappingURL=node.js.map
